// extracted by mini-css-extract-plugin
export default {"staticPageWrapper":"staticPage__staticPageWrapper-Jex3P","staticPage":"staticPage__staticPage-XNVUH"};